import { dynListTypes, gEnums } from 'global/enums/globalEnums'
import { listHelpers } from 'global/lists/lists'
import React, { useContext, useMemo } from 'react'
import _ from 'lodash'
import { ParentContext } from '../../ParentContext'

export const useDynamicListOptions = ({ groupItems, localData, currentViPropList, currentCollectionPropList, currentViProps }) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state, eventInfo_state, storage_state } = states ?? {}
  const { appDataDocuments } = eventInfo_state ?? {}
  const { aps_viewItems, aps_appUserSettings, viewItemsList, allPropsList } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appUserCollection, appUserViewTypeProp } = aps_appUserSettings ?? {}
  const viewItem_appUser = appUserCollection && aps_viewItems && aps_viewItems[appUserCollection] ? aps_viewItems[appUserCollection] : {}
  const { props: props_appUser } = viewItem_appUser ?? {}

  //   console.log('localData', localData)
  //   const _localData = useMemo(() => {
  //   return computeLocalData(rawData);
  // }, [rawData]);

  const dynOptions = useMemo(() => {

    const dl_opts = []

    const currentDynListProps = _.filter(groupItems, function (vp) {
      if (vp.data && vp.data.listType && dynListTypes[vp.data.listType]) {
        return vp.data.listType
      }
    });

    currentDynListProps.forEach(itemProp => {

      const { data, key: key_prop } = itemProp ?? {}
      const { listType: dynListType, listFrom, staticView: staticView_data, staticListProp: staticListProp_data, formItemType } = data ?? {}
      const { staticList } = staticListProp_data ?? {}

      let isNameSelect;

      switch (formItemType) {
        case gEnums.formItemTypes.nameSelect:
          isNameSelect = true
          break;
        default:
          isNameSelect = false
        // nothing
      }

      // list type can be for either listTypes OR dynListTypes

      switch (dynListType) {

        case dynListTypes.activeAppUserViewProps:
          const _props_appUser = props_appUser ? { ...props_appUser } : {}
          Object.keys(_props_appUser).forEach(key => {
            if (key.startsWith('_')) { delete _props_appUser[key] }
          })
          dl_opts[dynListType] = _props_appUser ? listHelpers.listListO(_props_appUser) : null
          break;

        case dynListTypes.activeViPropList:
          if (localData && listFrom && localData[listFrom]) {
            const listFromValue = localData[listFrom]
            if (appDataDocuments?.[listFromValue]) {
              const addValues = appDataDocuments[listFromValue]
              dl_opts[dynListType] = listHelpers.listStatic(addValues)
            }
          } else if (aps_viewItems) {
            dl_opts[dynListType] = listHelpers.listListO(aps_viewItems)
          }
          // ola[dynListType] = listList(viewItemsList)
          break;

        case dynListTypes.activePropList:
          dl_opts[dynListType] = currentViPropList ? listHelpers.listListO(currentViPropList) : null
          if (currentViProps) {
            dl_opts[dynListType] = listHelpers.listSimple(currentViProps)
          }
          break;

        case dynListTypes.activePropsList:
          dl_opts[dynListType] = currentViPropList ? listHelpers.listListO(currentViPropList) : null
          if (currentViProps) {
            dl_opts[dynListType] = listHelpers.listSimple(currentViProps)
          }
          break;


        case dynListTypes.allPropList:
          dl_opts[dynListType] = listHelpers.listList(allPropsList)
          break;

        case dynListTypes.activeViList:
          dl_opts[dynListType] = listHelpers.listList(viewItemsList)
          break;

        case dynListTypes.activeViPropList2:
          if (localData && listFrom && localData[listFrom]) {
            const listFromValue = localData[listFrom]
            if (appDataDocuments?.[listFromValue]) {
              const staticValues = appDataDocuments[listFromValue]
              dl_opts[dynListType] = listHelpers.listStatic(staticValues)
            }
          }
          break;

        case dynListTypes.activeStaticViewsList:
          if (staticListProp_data && appDataDocuments && appDataDocuments[staticList]) {
            dl_opts[dynListType] = listHelpers.listStatic(appDataDocuments[staticList])
          } else {
            dl_opts[dynListType] = listHelpers.listListO(appDataDocuments)
          }
          break;

        case dynListTypes.appUserViewTypeProps:
          if (appDataDocuments && appDataDocuments[appUserViewTypeProp]) {
            dl_opts[dynListType] = listHelpers.listStatic(appDataDocuments[appUserViewTypeProp], appUserViewTypeProp)
          }
          break;

        case dynListTypes.activeCollectionPropList:
          console.log('currentCollectionPropList', currentCollectionPropList)
          dl_opts[dynListType] = currentCollectionPropList ? listHelpers.listListO(currentCollectionPropList) : null
          break;

        // case dynListTypes.appPdfs:
        //   console.log('storage_state', storage_state)
        //   if (storage_state?.appStorageUrlFiles?.pdf) {
        //     dl_opts[dynListType] = listHelpers.listListO(storage_state?.appStorageUrlFiles?.pdf)
        //   } else {
        //     dl_opts[dynListType] = {}
        //   }
        //   break;

        // case dynListTypes.activeComponentList:
        //   dl_opts[dynListType] = listHelpers.listListI(componentContent)
        //   break;



        // case dynListTypes.itemPdf:
        //   if (storage_state && storage_state.appStorageUrlFiles && storage_state.appStorageUrlFiles.pdf) {
        //     dl_opts[dynListType] = listHelpers.listListO(storage_state.appStorageUrlFiles.pdf)
        //   } else {
        //     dl_opts[dynListType] = {}
        //   }
        //   break;

        // case dynListTypes.appUserViewTypeProps:
        //   if (appDataDocuments && appDataDocuments[appUserViewTypeProp]) {
        //     dl_opts[dynListType] = listHelpers.listStatic(appDataDocuments[appUserViewTypeProp], appUserViewTypeProp)
        //   }
        //   break;

        // case dynListTypes.activeAppUserViewProps:
        //   const _props_appUser = props_appUser ? { ...props_appUser } : {}
        //   Object.keys(_props_appUser).forEach(key => {
        //     if (key.startsWith('_')) { delete _props_appUser[key] }
        //   })
        //   dl_opts[dynListType] = _props_appUser ? listHelpers.listListO(_props_appUser) : null
        //   break;

        // case dynListTypes.activeAppUserView:
        //   dl_opts[dynListType] = additionalAppUserViewTypeProps ? listHelpers.listList([...additionalAppUserViewTypeProps, appUserCollection]) : listHelpers.listList([appUserCollection])
        //   break;

        // case dynListTypes.activeCollectionPropList:
        //   dl_opts[dynListType] = currentCollectionPropList ? listHelpers.listListO(currentCollectionPropList) : null
        //   break;

        // case dynListTypes.activePropList:
        //   dl_opts[dynListType] = currentViPropList ? listHelpers.listListO(currentViPropList) : null
        //   break;

        // case dynListTypes.activePropsList:
        //   dl_opts[dynListType] = currentViPropList ? listHelpers.listListO(currentViPropList) : null
        //   break;

        // case dynListTypes.activeSectionList:
        //   dl_opts[dynListType] = currentViPropList ? listHelpers.listListO(sectionsFromProps(currentViPropList)) : null
        //   break;

        // case dynListTypes.activeAppUserStaticView:
        //   if (appDataDocuments && appDataDocuments[appUserCollection]) {
        //     dl_opts[dynListType] = listHelpers.listStatic(appDataDocuments[appUserCollection], appUserCollection)
        //   }
        //   break;

        // case dynListTypes.activeStaticView:
        //   if (appDataDocuments && appDataDocuments[staticView_data]) {
        //     dl_opts[dynListType] = listHelpers.listStatic(appDataDocuments[staticView_data], staticView_data, null, isNameSelect, staticView_data)
        //   }
        //   break;

        // case dynListTypes.activeStaticViewsList:
        //   if (staticListProp_data && appDataDocuments && appDataDocuments[staticList]) {
        //     dl_opts[dynListType] = listHelpers.listStatic(appDataDocuments[staticList])
        //   } else {
        //     dl_opts[dynListType] = listHelpers.listListO(appDataDocuments)
        //   }
        //   break;

        // case dynListTypes.activeViList:
        //   dl_opts[dynListType] = listHelpers.listList(viewItemsList)
        //   break;

        // case dynListTypes.activeViPropList:
        //   if (data_combined && listFrom && data_combined[listFrom]) {
        //     const listFromValue = data_combined[listFrom]
        //     if (appDataDocuments && appDataDocuments[listFromValue]) {
        //       const staticValues = appDataDocuments[listFromValue]
        //       dl_opts[dynListType] = listHelpers.listStatic(staticValues)
        //     }
        //   } else if (aps_viewItems) {
        //     dl_opts[dynListType] = listHelpers.listListO(aps_viewItems)
        //   }
        //   // ola[dynListType] = listList(viewItemsList)
        //   break;

        // case dynListTypes.activeViPropList2:
        //   if (data_combined && listFrom && data_combined[listFrom]) {
        //     const listFromValue = data_combined[listFrom]
        //     if (appDataDocuments && appDataDocuments[listFromValue]) {
        //       const staticValues = appDataDocuments[listFromValue]
        //       dl_opts[dynListType] = listHelpers.listStatic(staticValues)
        //     }
        //   }
        //   // ola[dynListType] = listList(viewItemsList)
        //   break;

        // case dynListTypes.activeViListExceptSelf:
        //   dl_opts[dynListType] = listHelpers.listList(viewItemsList, null, updateProps && updateProps.vit)
        //   break;

        // case dynListTypes.activeViListPlusClient:
        //   dl_opts[dynListType] = listHelpers.listList(c.sort())
        //   break;

        // case dynListTypes.allPropList:
        //   dl_opts[dynListType] = listHelpers.listList(allPropsList)
        //   break;

        // case dynListTypes.appAddActions:
        //   dl_opts[dynListType] = listHelpers.listList(availableAddTypes)
        //   break;

        // case dynListTypes.appActions:
        //   dl_opts[dynListType] = listHelpers.listList(availableSubActionTypes)
        //   break;

        // case dynListTypes.settingsHandlers:
        //   dl_opts[dynListType] = listHelpers.listList(getAllHandlers(handlers))
        //   break;

        // case dynListTypes.settingsHandlerRts:
        //   if (data_combined && listFrom && data_combined[listFrom]) {
        //     const listFromValue = data_combined[listFrom]
        //     dl_opts[dynListType] = listHelpers.listList(getHandler(handlers, listFromValue))
        //   }
        //   break;

        default:
          break;
      }

      // LOOK
      // if (listFrom && data_combined && data_combined[listFrom]) {
      //   const listFromValue = data_combined[listFrom]
      //   switch (listFromValue) {
      //     case 'itemStatusType':
      //       dl_opts[key_prop] = listHelpers.listList(gEnums.statusTypes)
      //       break;
      //     default:
      //       const vi = aps_viewItems[listFromValue]
      //       const { props } = vi ?? {}
      //       const zz = props ? listHelpers.listListO(props) : {}
      //       dl_opts[key_prop] = zz
      //   }
      // }
    })

    return dl_opts
  }, [])
  //   }, [localData])

  return dynOptions

}
